// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","245":"component---src-pages-index-tsx","985":"component---src-pages-privacy-tsx"}[chunkId] || chunkId) + "-" + {"108":"b7b35f28e3706504f793","223":"53d36eb52fa0d7d34bd6","245":"89608548c89723797df8","452":"bf626248af6a63d06479","985":"a09f45ee75a5f3176633"}[chunkId] + ".js";
};